/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {DeprecatedAccessModule} from '../models/DeprecatedAccessModule';
import type {Error} from '../models/Error';

export interface GetDeprecatedAccessModules$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getDeprecatedAccessModulesRequest = createAction<PayloadData<void>>('LICENSE_ACCESS_MODULES__GET_DEPRECATED_ACCESS_MODULES__REQUEST');
export const getDeprecatedAccessModulesSuccess = createAction<PayloadData<Array<DeprecatedAccessModule>>>('LICENSE_ACCESS_MODULES__GET_DEPRECATED_ACCESS_MODULES__SUCCESS');
export const getDeprecatedAccessModulesFailure = createAction<PayloadData<Error, void, true>>('LICENSE_ACCESS_MODULES__GET_DEPRECATED_ACCESS_MODULES__FAILURE');

export const getDeprecatedAccessModulesActions = [
    getDeprecatedAccessModulesRequest,
    getDeprecatedAccessModulesSuccess,
    getDeprecatedAccessModulesFailure
] as const;

/**
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getDeprecatedAccessModules = (config?: GetDeprecatedAccessModules$Config) => {
    return {
        CALL_API: {
            types: getDeprecatedAccessModulesActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/licenses/deprecated-access-modules`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        }
    }
};

